import { createSlice } from '@reduxjs/toolkit';

interface MenuState {
    isNavMenuOpen: boolean;
    isProfileMenuOpen: boolean;
}

const initialState: MenuState = {
    isNavMenuOpen: false,
    isProfileMenuOpen: false,
};

const menuSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        openNavMenu: (state) => {
            state.isNavMenuOpen = true;
        },
        closeNavMenu: (state) => {
            state.isNavMenuOpen = false;
        },
        openProfileMenu: (state) => {
            state.isProfileMenuOpen = true;
        },
        closeProfileMenu: (state) => {
            state.isProfileMenuOpen = false;
        },
    },
});

export const {
    openNavMenu,
    closeNavMenu,
    openProfileMenu,
    closeProfileMenu
} = menuSlice.actions;

export default menuSlice.reducer;
